/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Extension_Step1title1Inputs */

const he_extension_step1title1 = /** @type {(inputs: Extension_Step1title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`התקן את התוסף`)
};

const en_extension_step1title1 = /** @type {(inputs: Extension_Step1title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Install the Extension`)
};

/**
* | output |
* | --- |
* | "Install the Extension" |
*
* @param {Extension_Step1title1Inputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
const extension_step1title1 = /** @type {((inputs?: Extension_Step1title1Inputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Extension_Step1title1Inputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_extension_step1title1(inputs)
	return en_extension_step1title1(inputs)
});
export { extension_step1title1 as "extension_step1Title" }